import { ChevronDown } from "lucide-react";
import { Reveal } from "./Reveal";

export const Faq = ({ items }) => (
    <div className="space-y-4">
        {items.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.05}>
                <details className="group bg-white border border-hairline rounded-2xl px-6 py-5 open:shadow-[0_12px_40px_-18px_rgba(24,59,43,0.25)] transition-shadow duration-300" data-testid={`faq-item-${i + 1}`}>
                    <summary className="flex items-center justify-between gap-4 cursor-pointer list-none font-display font-semibold text-ink text-base sm:text-lg [&::-webkit-details-marker]:hidden">
                        {f.q}
                        <ChevronDown size={18} className="shrink-0 text-leaf transition-transform duration-200 group-open:rotate-180" />
                    </summary>
                    <p className="mt-3 text-base text-shade leading-relaxed">{f.a}</p>
                </details>
            </Reveal>
        ))}
    </div>
);
